import { api } from '../lib/api.js';
import type { stationApi } from './station.js';

// „תלת מימד" במסכי המשרד (שרת: modules/projects/project-model.routes.ts) — מאחורי
// סשן, עובד גם מחוץ למפעל. הקיוסק ממשיך עם `stationApi.model3d` / `modelStatus`.
type ModelStatus = Awaited<ReturnType<typeof stationApi.modelStatus>>;

export const projectModelApi = {
  get: (projectNumber: string) =>
    api<{ url: string | null; kind: 'glb' | 'html' | null }>(`/api/project-model?projectNumber=${encodeURIComponent(projectNumber)}`),
  status: (projectNumber: string) =>
    api<ModelStatus>(`/api/project-model/status?projectNumber=${encodeURIComponent(projectNumber)}`),
};
